import { useAppSelector } from "@/redux/store/hooks";

export function useIsPrivateIdeaMediaBucketEnabled(): boolean {
  const { features } = useAppSelector((state) => state.features);
  return Boolean(features?.enablePrivateBucketForIdeas?.enabled);
}
